<template>
    <div v-if="componentShow">
        <span v-if="col.formatter && col.toButton"><a href="javaScript:void(0);" @click="col.toButton(row[col.value],row,col.value)"
        >{{ col.formatter(row[col.value],row) }}</a></span><span
            v-else-if="col.formatter">{{ col.formatter(row[col.value],row) }}</span><span
            v-else-if="col.annex"><el-button
            @click.native.prevent="col.annex(row[col.value],row,col.value)"
            type="text"
            size="small" style="padding: 0px 15px">
        <img src="../../assets/icon/jianlifujian.png" alt="附件" v-if="row[col.value]">
    </el-button></span><span
            v-else-if="col.toButton"><a href="javaScript:void(0);" @click="col.toButton(row[col.value],row,col.value,column)"
    >{{ row[col.value] }}</a></span><span
            v-else-if="col.filter">{{$options.filters[col.filter](row[col.value])}}</span><span
            v-else-if="col.i18n && row[col.value]">{{ $t(col.i18n+'.'+row[col.value]) }}</span><span
            v-else>{{ row[col.value] }}</span>
    </div>
</template>

<script>
    export default {
        name: 'ZmCol',
        props: {
            col: {
                type: Object
            },
            row: {
                type: Object
            },
            column:{
                type: Object
            }
        },
        data(){
            return {
                componentShow:true
            }
        },
        beforeDestroy(){
            this.componentShow = false;
        }
    }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/CommonTable/ZmCol.vue